var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home d-flex justify-center pa-5"},[_c('span',{staticClass:"text-h3"},[_vm._v(" Comming soon :) ")])])
}]

export { render, staticRenderFns }